export default function optionFieldset({main, on, elm, state, subscribe}) {
    main(_ => {
        elm.addEventListener('change', changeLabel);
        subscribe('available-values', changeAvailableValues);
    });

    const changeLabel = function(e) {
        if (e.target.type !== 'radio') return;

        state.set(s => s.selectedValue = e.target.dataset.name )
    }

    const changeAvailableValues = function(available) {
        const {optionId} = state.get();
		const selectedElement = elm.querySelector('input[type="radio"]:checked, select option:checked');
        const selectedValue = selectedElement.dataset.valueId;

        if (available[optionId]) {
            if (!available[optionId].has(selectedValue)){
                const formValidation = elm.closest('form-validation');
                const name = elm.querySelector('input[type="radio"]:first-of-type, select').name;

				const valueIds = [...available[optionId]];
				const firstEl = elm.querySelector(`input[type="radio"]:is(${valueIds.map(id => `[data-value-id="${id}"]`).join(', ')}), select option:first-child`);
				firstEl.checked = true;

                const event = new Event('change', { bubbles: true });
                firstEl.dispatchEvent(event);

                const values = {};
                values[name] = firstEl.value;

                formValidation.setValues(values);
            } else {
                state.set(s => s.activeValues = [...available[optionId]]);
            }

			if (selectedElement.tagName === 'OPTION') {
				const options = elm.querySelectorAll('select option');

				options.forEach((option) => {
					option.disabled = !available[optionId].has(option.dataset.valueId);
				});

				const choices = elm.querySelector('select-choices').choices;
				const reset = !available[optionId].has(selectedValue);
				choices.refresh();
				if (reset) {
					const firstEl = elm.querySelector('select option:first-child');
					choices.setChoiceByValue(firstEl.value);
				}
			}
        }
    };
}

export const model = {};
